export const statusOptions = [
  "In Review",
  "Shortlisted",
  "Interview In-Progress",
  "Selected",
  "Offer Released",
  "Offer Accepted",
  "Offer Declined",
  "Offer Revised",
  "Offer Revoked",
  "Joined",
  // "On Hold",
  "Rejected",
  "Not Joined",
];

export const offerStatuses = [
  "Offer Released",
  "Offer Accepted",
  "Offer Revised",
  "Offer Declined",
  "Offer Revoked",
];

export const eventCategories = [
   // Professional & Educational
  'Startup',
  'Business',
  'Networking',
  'Conference',
  'Seminar',
  'Workshop',
  'Training',
  'Webinar',
  'Panel Discussion',
  'Product Launch',
  'Investor Meet',
  'Pitch Competition',
  'Job Fair',
  'Hackathon',
  'Bootcamp',

  // Social & Cultural
  'Festival',
  'Celebration',
  'Party',
  'Reunion',
  'Wedding',
  'Anniversary',
  'Birthday',
  'Cultural Event',
  'Religious Event',
  'Community Gathering',
  'Fundraiser',
  'Charity Event',

  // Entertainment & Lifestyle
  'Music',
  'Concert',
  'DJ Night',
  'Art Exhibition',
  'Fashion Show',
  'Theatre',
  'Movie Screening',
  'Dance Event',
  'Food & Drink',
  'Cooking Class',
  'Book Reading',
  'Gaming Tournament',

  // Sports & Wellness
  'Sports',
  'Marathon',
  'Yoga Session',
  'Fitness Bootcamp',
  'Zumba Class',
  'Health Talk',
  'Meditation Retreat',

  // Awareness & Causes
  'Awareness Campaign',
  'Blood Donation',
  'Clean-up Drive',
  'Environmental Event',
  'Volunteer Event',
  'Protest',
  'Panel on Social Issues',

  // Technology & Innovation
  'Tech Talk',
  'Developer Meetup',
  'AI Workshop',
  'Blockchain Event',
  'IoT Showcase',
  'Startup Demo Day',
  'Innovation Fair',

  // Youth & Education
  'School Event',
  'College Fest',
  'Orientation',
  'Talent Show',
  'Debate',
  'Quiz',
];
